import { LocalTypes } from '../types/Requirements';
import { merge } from 'lodash';
import Loader, { loadWrap } from './mixins/Loader';
import ApiService from '@jobstairs/axios-api-service';
import { isEmpty } from 'lodash';
import tokenService from '@/services/TokenService';

const REQUIREMENT_GROUP_MAPPING = {
    edu_focus: 'educationFocus',
    edu_types: 'educationTypes',
    opt_edu_types: 'optionalEducationTypes',
    requirements: 'requirements',
    opt_requirements: 'optionalRequirements',
    per_traits: 'personalTraits',
};

function transform(extractedEntities) {
    const entries = Object.entries(extractedEntities).map(([key, value]) => {
        const newKey = REQUIREMENT_GROUP_MAPPING[key.toLowerCase()] || key;
        const formattedValue = value.content.map(
            (item) => item['suggested_name'],
        );

        return [newKey, formattedValue];
    });
    return Object.fromEntries(entries);
}

export default function ({ baseURL, endpoints }) {
    const apiService = new ApiService({ baseURL: baseURL });

    return merge(Loader(), {
        state: {
            requirements: {},
        },
        getters: {},
        actions: {
            async [LocalTypes.actions.LOAD_REQUIREMENTS](
                { commit },
                { jobAdId },
            ) {
                await loadWrap(commit, async () => {
                    const response = await apiService.get({
                        endpoint:
                            endpoints.analysisById +
                            `?id=${jobAdId}` +
                            `&use_deepl=false`,
                        headers:
                            tokenService.getAuthenticationHeader()['headers'],
                    });
                    if (
                        `${response.status}` === '204' ||
                        isEmpty(response.data)
                    ) {
                        throw new Error('204');
                    }
                    const formattedRequirements = transform(
                        response.data['entity_extraction'],
                    );
                    commit(
                        LocalTypes.mutations.SET_REQUIREMENTS,
                        formattedRequirements,
                    );
                });
            },
            async [LocalTypes.actions.LOAD_REQUIREMENTS_FREETEXT](
                { commit },
                { text },
            ) {
                await loadWrap(commit, async () => {
                    const response = await apiService.post({
                        endpoint: endpoints.freetextAnalysis,
                        data: { html: text, use_deepl: false },
                        headers:
                            tokenService.getAuthenticationHeader()['headers'],
                    });
                    if (
                        `${response.status}` === '204' ||
                        isEmpty(response.data)
                    ) {
                        throw new Error('204');
                    }
                    const formattedRequirements = transform(
                        response.data['entity_extraction'],
                    );
                    commit(
                        LocalTypes.mutations.SET_REQUIREMENTS,
                        formattedRequirements,
                    );
                });
            },
        },
        mutations: {
            [LocalTypes.mutations.SET_REQUIREMENTS]: (state, requirements) => {
                state.requirements = requirements;
            },
        },
    });
}
